import {React, styled} from 'common'
import {Page} from '.'
import {Colors} from 'appearance'
import LoadingDots from 'components/Display/LoadingDots'

const Loading = ({pageTitle, loadingText, isLoading}) => {
    return (
        <Page title={pageTitle}>
            <TitleRow>
                <Title>{loadingText}</Title>
                <LoadingDots isLoading={isLoading} />
            </TitleRow>
        </Page>
    )
}

export default Loading

const Title = styled.h1`
    color: ${Colors.TORQUISE};
    padding: 5px;
    margin-left: 20px;

    animation: blinker 2s linear infinite;
    font-family: sans-serif;
    @keyframes blinker {
        50% {
            opacity: 0.4;
        }
    }
`
const TitleRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 5px;
`
